// Strings for S5. Only the S5 worker edits this file (see web/README.md).
// Copy from prototype/assets/app.js (screens.S5) and ux-flow.md S5; DRAFT = no source there (w2-03 report).
export default {
  title: "Here's what we know",
  'money.lede': 'You could be owed up to',
  'money.per': 'per passenger',
  'money.perIfConfirmed': 'per passenger, if we confirm it',
  // w5-06 (Q4): an intra-EU/EEA/CH flight over 3,500 km is capped at the middle band. Keyed by
  // regime (w6-02): under UK 261 the area and the figures differ, and no euro figure may show.
  'money.cap':
    'Why not €600? Between airports in the EU, Norway, Iceland, Liechtenstein and Switzerland, EC 261 pays at most {amount}, however far the flight.', // DRAFT
  'money.cap.UK261':
    'Why not £520? Between airports in the UK, UK 261 pays at most {amount}, however far the flight.', // DRAFT (w6-02)
  'facts.scheduled': 'Scheduled arrival',
  'facts.actual': 'Actual arrival',
  'facts.distance': 'Distance',
  'facts.km': '{km} km',
  'facts.rule': 'Rule',
  'actual.never': 'never arrived',
  'actual.noData': 'no data yet',
  'actual.diverted': 'landed elsewhere', // DRAFT
  'actual.late': '{time} · {delay} late',
  'actual.onTime': '{time} · on time',
  'regime.EC261': 'EC 261',
  'regime.UK261': 'UK 261',
  'regime.none': 'Not EU or UK', // DRAFT

  'eligible.ask': 'Are these details right?',
  'eligible.note': 'Checking is free, and we only get paid if your claim succeeds.',
  'eligible.yes': 'Yes, continue',
  'eligible.no': "No, something's different",

  'below.ask': 'Our data shows {what}. Is that what you experienced?',
  'below.late': 'it arrived {delay} late',
  'below.onTime': 'it arrived on time',
  'below.note': "We're not turning you away — if you arrived later than this, say so and we'll look again.",
  'below.yes': "Yes, that's right",
  'below.no': 'No, it was longer',

  'pending.ask': "We don't have status data for this flight yet.",
  'pending.note':
    "That's normal for some routes. Tell us what happened and we'll verify it with the airline's records.",
  'pending.yes': 'Tell us what happened',

  // Regime "none" (contract `not_covered`): no state in ux-flow.md, DECISION-NEEDED
  'notCovered.note': "One more question and we'll check which rules apply to this flight.", // DRAFT

  saveFailed: "That didn't save. Check your connection and try again.", // DRAFT
} as const;
